import {
  CompositeTableTemplate,
  renderCellGrayZeros,
} from 'app/common/templates-next/table-template'

import { ReportFinancesDataReplenishmentStudent } from 'app/dataTypes/reports/data/common/financesSummaryReplenishment'

import { useStudentsTableData } from './useStudentsTableData'
import { renderTableCell } from './renderTableCell'

type Props = {
  data: ReportFinancesDataReplenishmentStudent
  currency: string
}

export const ByStudentsTable = ({ data, currency }: Props) => {
  const tableData = useStudentsTableData(data, currency)

  return (
    <CompositeTableTemplate
      data={tableData}
      renderCell={renderTableCell}
      renderFooterCell={renderCellGrayZeros}
      borderTop
    />
  )
}
